import {Path, Rect, Svg} from 'react-native-svg';

const SettingsPasswordIcon = () => (
  <Svg width="30" height="30" viewBox="0 0 30 30" fill="none">
    <Rect width="30" height="30" rx="7" fill="#2E2EAB" />
    <Path
      d="M10.7373 23.1182H19.2627C20.4404 23.1182 21.0205 22.5381 21.0205 21.2549V14.6719C21.0205 13.5117 20.5459 12.9229 19.5615 12.8262V10.6553C19.5615 7.31543 17.3379 5.70703 15 5.70703C12.6621 5.70703 10.4385 7.31543 10.4385 10.6553V12.8525C9.52441 12.9932 8.97949 13.5732 8.97949 14.6719V21.2549C8.97949 22.5381 9.55957 23.1182 10.7373 23.1182ZM12.126 10.4971C12.126 8.44922 13.4268 7.32422 15 7.32422C16.5645 7.32422 17.874 8.44922 17.874 10.4971V12.8086L12.126 12.8174V10.4971Z"
      fill="white"
    />
  </Svg>
);

export default SettingsPasswordIcon;
